import { ApisauceConfig, create } from 'apisauce';
import { isEmpty, omitBy } from 'lodash';

import { apiMap, ApiNamespace, apiPorts, apiUrl, imageOriginUrl } from '@config/api';
import { useLocalServicePorts } from '@config/runtimeConfig';
import { removeAtsSubscriberFromSessionStorage } from '@utils/atsSubscriberUtils';

import { transformAdminRequest, transformSubscriberRequest } from '../auth/utils';

export const getApiBaseUrl = (api?: ApiNamespace) =>
  api && useLocalServicePorts
    ? `${apiUrl}:${apiPorts[api]}`
    : api
      ? `${apiUrl}/${apiMap[api]}`
      : apiUrl;

export const getTitleImageOriginBaseUrl = (scope: 'collections' | 'titles'): string =>
  `${imageOriginUrl}/images/${scope}`;

export const getImageManagerBaseUrl = () => `${apiUrl}/imagemanager/admin`;

export const getClientPreviewParams = (params?: URLSearchParams) =>
  omitBy(
    {
      'x-device-type-id': params?.get('device'),
      country: params?.get('country')?.toLowerCase(),
      partner: params?.get('partner'),
    },
    isEmpty
  );

export const createAdminApi = (baseURL: string, headers: ApisauceConfig['headers']) => {
  const api = create({ baseURL, headers });
  api.axiosInstance.interceptors.request.use(transformAdminRequest);
  return api;
};

export const createSubscriberApi = (baseURL: string, headers: ApisauceConfig['headers']) => {
  const api = create({ baseURL, headers });
  api.axiosInstance.interceptors.request.use(transformSubscriberRequest);

  api.addMonitor(async response => {
    if (response.status === 401) removeAtsSubscriberFromSessionStorage();
  });

  return api;
};

export const createAnonymousApi = (baseURL: string) => {
  const api = create({
    baseURL,
    headers: { 'cache-control': 'no-cache', expires: '0', pragma: 'no-cache' },
  });

  return api;
};
